import { DropdownMenuItem } from '@/components/ui/dropdown-menu'
import {
  idxColumn,
  nameColumn,
  mediaSourceColumn,
  countryColumn,
  ownerColumn,
  pidColumn,
  statusColumn,
  createActionsColumn,
} from '../columns/common-columns'
import { CopyItem } from '@/components/zthd/DropdownMenu'
import { formatPercent, formatUSD } from '@/lib/format-utils'

const totalCostColumn = {
  accessorKey: 'totalCost',
  header: 'Cost',
  cell: ({ row }) => formatUSD(row.original.totalCost),
  sortingFn: 'basic',
  sortDescFirst: true,
  enableSorting: true,
}

const cpiColumn = {
  id: 'cpi',
  header: 'CPI',
  enableSorting: true,
  cell: ({ row }) => {
    const cost = row.original.totalCost || 0
    const installs = row.original.totalInstalls || 0
    const cpi = installs ? cost / installs : 0
    return formatUSD(cpi)
  },
  accessorFn: (row) => {
    const cost = row.totalCost || 0
    const installs = row.totalInstalls || 0
    return installs ? cost / installs : 0
  },
  sortingFn: 'basic',
  sortDescFirst: true,
}

const totalRevenueColumn = {
  accessorKey: 'totalRevenue',
  header: 'Revenue',
  cell: ({ row }) => formatUSD(row.original.totalRevenue),
  sortingFn: 'basic',
  sortDescFirst: true,
  enableSorting: true,
}

const weeklyCostColumn = {
  accessorKey: 'weeklyCost',
  header: 'Weekly Cost',
  cell: ({ row }) => formatUSD(row.original.weeklyCost),
  sortingFn: 'basic',
  sortDescFirst: true,
  enableSorting: true,
}

const profitColumn = {
  id: 'profit',
  header: 'Profit',
  enableSorting: true,
  cell: ({ row }) => {
    const profit =
      (row.original.totalRevenue || 0) - (row.original.totalCost || 0)
    return formatUSD(profit)
  },
  accessorFn: (row) => {
    return (row.totalRevenue || 0) - (row.totalCost || 0)
  },
  sortingFn: 'basic',
  sortDescFirst: true,
}

const roasColumn = {
  id: 'roasTotal',
  header: 'Total',
  enableSorting: true,
  cell: ({ row }) => {
    const cost = row.original.totalCost || 0
    const revenue = row.original.totalRevenue || 0
    const roas = cost ? revenue / cost : 0
    return formatPercent(roas)
  },
  accessorFn: (row) => {
    const cost = row.totalCost || 0
    const revenue = row.totalRevenue || 0
    return cost ? revenue / cost : 0
  },
  sortingFn: 'basic',
  sortDescFirst: true,
}

const daysRoasColumn = (day) => ({
  id: `daysRoas${day}`,
  header: `D${day}`,
  enableSorting: true,
  cell: ({ row }) => {
    const roasData = row.original.daysRoas?.[`day${day}`] || 0
    if (!roasData || !roasData.cost) return formatPercent(0)
    const roas = roasData.revenue / roasData.cost
    return formatPercent(roas, 2, 2)
  },
  accessorFn: (row) => {
    const roasData = row.daysRoas?.[`day${day}`] || 0
    if (!roasData || !roasData.cost) return 0
    const roas = roasData.revenue / roasData.cost
    return roas
  },
  sortingFn: 'basic',
  sortDescFirst: true,
})

export const getColumns = (days) => [
  idxColumn,
  {
    ...nameColumn,
    enableSorting: false,
  },
  {
    ...mediaSourceColumn,
    enableSorting: false,
  },
  {
    ...countryColumn,
    enableSorting: false,
  },
  {
    ...ownerColumn,
    enableSorting: false,
  },
  {
    ...statusColumn,
    enableSorting: false,
  },
  totalRevenueColumn,
  totalCostColumn,
  cpiColumn,
  {
    id: 'roas',
    header: 'ROAS',
    columns: [...days.map((day) => daysRoasColumn(day)), roasColumn],
  },
]
